import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for Traveler
 *
 */

const Traveler = lazyLoad(
  () => import('app/modules/Traveler'),
  (module) => module.default,
);

export default Traveler;
